import React, { useEffect, useState } from 'react';
import { makeUrl, errorCallback } from '../constant';
import { SUPPLIERS_URL, getFetchRequest, postFetchRequest } from '../store/requests';

const PurchasesCounterpartiesTab = ({ isCollapsed }) => {
    const [suppliers, setSuppliers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isCreateMode, setIsCreateMode] = useState(false);
    const [name, setName] = useState('');
    const [saving, setSaving] = useState(false);

    const loadSuppliers = () => {
        setIsLoading(true);
        setError(null);
        getFetchRequest(
            makeUrl([SUPPLIERS_URL]),
            (data) => {
                setSuppliers(Array.isArray(data) ? data : []);
                setIsLoading(false);
            },
            (err) => {
                errorCallback(err);
                setError(err?.message || 'Не удалось загрузить контрагентов-поставщиков');
                setIsLoading(false);
            }
        );
    };

    useEffect(() => {
        loadSuppliers();
    }, []);

    const handleSave = () => {
        const trimmed = (name || '').trim();
        if (!trimmed) {
            alert('Пожалуйста, введите название организации.');
            return;
        }
        setSaving(true);
        postFetchRequest(
            makeUrl([SUPPLIERS_URL]),
            { name: trimmed },
            () => {
                setSaving(false);
                setIsCreateMode(false);
                setName('');
                loadSuppliers();
            },
            (err) => {
                errorCallback(err);
                alert('Не удалось сохранить контрагента-поставщика. Попробуйте позже.');
                setSaving(false);
            },
            true
        );
    };

    return (
        <section className={`page-content ${isCollapsed === null ? '' : isCollapsed ? 'page-content_collapsed' : 'page-content_full-width'}`}>
            {isCreateMode ? (
                <article className="users">
                    <div className="order-detail-header">
                        <button
                            className="order-detail-back-btn"
                            type="button"
                            onClick={() => setIsCreateMode(false)}
                        >
                            <svg
                                width="31"
                                height="12"
                                viewBox="0 0 31 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.219667 4.99262C-0.073225 5.28551 -0.073225 5.76039 0.219667 6.05328L4.99264 10.8263C5.28553 11.1191 5.76041 11.1191 6.0533 10.8263C6.34619 10.5334 6.34619 10.0585 6.0533 9.76559L1.81066 5.52295L6.0533 1.28031C6.34619 0.987415 6.34619 0.512542 6.0533 0.219648C5.76041 -0.073245 5.28553 -0.073245 4.99264 0.219648L0.219667 4.99262ZM30.75 5.52295V4.77295L0.749998 4.77295V5.52295V6.27295L30.75 6.27295V5.52295Z"
                                    fill="#666666"
                                />
                            </svg>
                            Назад
                        </button>
                    </div>
                    <h2 className="clients-toolbar__title">Создание контрагента-поставщика</h2>
                    <div className="create-customer-form">
                        <div className="create-customer-form__field">
                            <label>Название организации</label>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="ООО «Поставщик»"
                            />
                        </div>
                        <div className="create-customer-form__actions">
                            <button
                                type="button"
                                className="button button-secondary"
                                onClick={() => setIsCreateMode(false)}
                                disabled={saving}
                            >
                                Отменить
                            </button>
                            <button
                                type="button"
                                className="button"
                                onClick={handleSave}
                                disabled={saving}
                            >
                                {saving ? 'Сохранение...' : 'Сохранить'}
                            </button>
                        </div>
                    </div>
                </article>
            ) : (
                <article className="users">
                    <div className="clients-toolbar">
                        <button
                            type="button"
                            className="clients-toolbar__create"
                            onClick={() => setIsCreateMode(true)}
                        >
                            Создать контрагента +
                        </button>
                        <div className="clients-toolbar__search">
                            <input type="text" placeholder="Поиск ...." />
                            <svg
                                className="clients-toolbar__search-icon"
                                width="19"
                                height="19"
                                viewBox="0 0 19 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.7938 14.6615C14.6355 14.6615 17.7498 11.5473 17.7498 7.70574C17.7498 3.86419 14.6355 0.75 10.7938 0.75C6.95218 0.75 3.83789 3.86419 3.83789 7.70574C3.83789 11.5473 6.95218 14.6615 10.7938 14.6615Z"
                                    stroke="#1C1C1C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M5.87594 12.6245L0.75 17.7503"
                                    stroke="#1C1C1C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="clients-table clients-table--counterparties">
                        <div className="clients-table__header">
                            <div className="clients-table__row">
                                <div className="clients-table__cell clients-table__cell--id">№</div>
                                <div className="clients-table__cell">Название контрагента</div>
                            </div>
                        </div>
                        <div className="clients-table__body">
                            {error && (
                                <div className="clients-table__row">
                                    <div className="clients-table__cell" style={{ gridColumn: '1 / -1' }}>
                                        {error}
                                    </div>
                                </div>
                            )}
                            {!error && isLoading && (
                                <div className="clients-table__row">
                                    <div className="clients-table__cell" style={{ gridColumn: '1 / -1' }}>
                                        Загрузка контрагентов-поставщиков...
                                    </div>
                                </div>
                            )}
                            {!error && !isLoading && suppliers.length === 0 && (
                                <div className="clients-table__row">
                                    <div className="clients-table__cell" style={{ gridColumn: '1 / -1' }}>
                                        Контрагенты-поставщики не найдены
                                    </div>
                                </div>
                            )}
                            {!error && !isLoading && suppliers.length > 0 && suppliers.map((s, index) => (
                                <div key={s.id} className="clients-table__row">
                                    <div className="clients-table__cell clients-table__cell--id">{index + 1}</div>
                                    <div className="clients-table__cell">{s.name}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </article>
            )}
        </section>
    );
};

export default PurchasesCounterpartiesTab;
